/**
 * Preview bypass for the "coming soon" gate. NOT a security boundary — the API
 * enforces auth + admin server-side. This only controls what the browser
 * renders. Visit `?preview=1` to enable (persists in localStorage so it
 * survives the Cognito sign-in redirect), `?preview=0` to clear.
 */
const KEY = "th_preview";

export function syncPreviewFlag(): void {
  const p = new URLSearchParams(window.location.search).get("preview");
  if (p === "1") localStorage.setItem(KEY, "1");
  else if (p === "0") localStorage.removeItem(KEY);
}

export function previewEnabled(): boolean {
  return localStorage.getItem(KEY) === "1";
}
